












































import {
  Vue,
  Component,
  Prop,
  Watch
} from "@/shared/vuepack";
import { MfaStatusEnum } from "@/shared/types";
import { Validator } from "vee-validate";
import LoginWrapper from "@/shared/components/ui/LoginWrapper.vue";
import Button from "@/shared/components/ui/Button.vue";
import PasswordRequirements from "@/shared/components/PasswordRequirements.vue";
import { ToHome } from "@/shared/route-names";
import { RawLocation } from "vue-router";
import { useNotifierStore } from "@/shared/store/notifier";
import { useMfaStore } from "@/shared/store/mfa";
import { useUserStore } from "@/shared/store/user";

@Component({
  components: {
    LoginWrapper,
    Button,
    PasswordRequirements
  },
  props: {
    username: null
  }
})
export default class LoginVerify extends Vue {
  $validator: Validator;

  notifierStore = useNotifierStore();
  userStore = useUserStore();
  mfaStore = useMfaStore();

  @Prop()
  MfaRouteFunc: (username: string, password: string, mfaStatus: MfaStatusEnum) => RawLocation;

  isSubmitting = false;
  password = "";
  verificationCode = "";
  username: string;
  confirmPassword = "";

  @Watch("userStore.loggedIn")
  onLoggedIn (newValue) {
    if (!newValue) return;

    const destination = this.$route.query && this.$route.query.returnUrl ?
        this.$route.query.returnUrl as string : ToHome;
    this.$router.push(destination);
  }

  get submitDisabled () {
    return this.isSubmitting;
  }

  get confirmPasswordValidation () {
    return {
      required: !!this.password,
      confirmed: !!this.confirmPassword && this.password
    };
  }

  get FormattedVerificationCode (): string {
    return this.verificationCode.replace(/\s/g, "");
  }

  mfaCheck () {
    if (this.mfaStore.mfaStatus === MfaStatusEnum.Disabled) {
      return;
    }

    this.$router.push(this.MfaRouteFunc(this.username, this.password, this.mfaStore.mfaStatus));
  }

  authConfirmPassword () {
    this.userStore.submitVerificationCode({
          username: this.username, verificationCode: this.FormattedVerificationCode,
          password: this.password
        })
        .then(() => this.mfaCheck())
        .catch(err => {
          if (err && err.message) {
            this.notifierStore.setDanger(err.message);
          } else if (err && err.code) {
            this.notifierStore.setDanger(`An error has occured. Error Code: ${err.code}`);
          } else {
            this.notifierStore.setDanger("Unknown error");
          }

          this.isSubmitting = false;
        });
  }

  onSubmit () {
    this.$validator
        .validateAll()
        .then(result => {
          if (!result) return;
          this.isSubmitting = true;
          this.authConfirmPassword();
        })
        .catch(error => {
          if (error && error.message) {
            this.notifierStore.setDanger(error.message);
          }
        });
  }
}
